import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./vp7200.css";

function VP7200() {
  const [mainImage, setMainImage] = useState("/images/7200/1-1.png");
  const [activeTab, setActiveTab] = useState("features");

  const thumbnails = [
    "/images/7200/1-1.png",
    "/images/7200/1-2.png",
    "/images/7200/1-3.png",
    "/images/7200/1-4.png",
    "/images/7200/1-5.png"
  ];
  return (
    <>
      <Header />
      <section className="vp7200-container">

        {/* LEFT SIDE */}
        <div className="vp7200-left">
          <div className="main-image">
            <img src={mainImage} alt="VP7200" />
          </div>

          {/* <div className="thumbnails">
            {thumbnails.map((img, index) => (
              <img
                key={index}
                src={img}
                alt=""
                onClick={() => setMainImage(img)}
              />
            ))}
          </div> */}
          <div className="thumbnails">

            {/* TOP ROW (2 IMAGES) */}
            <div className="thumb-row top-row">
              {thumbnails.slice(0, 3).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt=""
                  onClick={() => setMainImage(img)}
                />
              ))}
            </div>

            {/* BOTTOM ROW (3 IMAGES) */}
            <div className="thumb-row bottom-row">
              {thumbnails.slice(3, 5).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt=""
                  onClick={() => setMainImage(img)}
                />
              ))}
            </div>

          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="vp7200-right">

          {/* TOP CONTENT */}
          <div className="content-top">
            <h1>VP7200</h1>
            <h3>Secure Contactless Payment Reader with Camera</h3>

            <p>
              The VP7200 is a <b>compact, powerful and rugged</b> unattended contactless payment reader designed for self-service environments where space, durability and <b>fast tap-to-pay</b> performance matter.
            </p>

            <p>
              Ideal for <b>parking, transport ticketing, kiosks and other unattended applications,</b> it combines strong security, broad contactless acceptance and <b>QR/barcode scanning</b> in a sleek, low-power device built for reliable everyday use.
            </p>
          </div>

          {/* TABS */}
          <div className="tabs">
            <button
              className={activeTab === "features" ? "active" : ""}
              onClick={() => setActiveTab("features")}
            >
              KEY FEATURES
            </button>

            <button
              className={activeTab === "specs" ? "active" : ""}
              onClick={() => setActiveTab("specs")}
            >
              SPECIFICATIONS
            </button>
          </div>

          {/* TAB CONTENT */}
          <div className="tab-content">
            {activeTab === "features" && (
              <ul>
                <li>PCI PTS 6.X certified with latest contactless kernels</li>
                <li>Supports tap-to-pay with NFC-enabled cards and mobile wallets</li>
                <li>Supports Apple Pay, Google Pay, Apple VAS and Google Smart Tap</li>
                <li>Built-in camera for QR/barcode scanning</li>
                <li>Compact, stylish and rugged design with IP65 and IK07 ratings</li>
                <li>Optional cellular/LTE support</li>
                <li>Can host and run payment applications</li>
                <li>Ability to drive an external screen for customer engagement</li>
                <li>Low power consumption</li>
                <li>Suitable for indoor and outdoor unattended use</li>
              </ul>
            )}

            {activeTab === "specs" && (
              <ul>
                <li>Connectivity: USB-C, Ethernet, LTE</li>
                <li>Operating Temp: -30°C to 70°C</li>
                <li>Security: PCI PTS 6.x</li>
                <li>Ingress Protection: IP65</li>
                <li>Dimensions: Compact form factor</li>
              </ul>
            )}
          </div>
        </div>
      </section>
      <section className="vp7200-benefits">

        <div className="vp7200-benefits-container">

          {/* LEFT CONTENT */}
          <div className="benefits-left">
            <h2>Smarter Payments Start with the VP7200</h2>

            <p>
              Built with both security and customer experience in mind, it delivers fast,
              reliable payments while supporting modern digital wallets and loyalty programs.
            </p>

            <ul>
              <li>Improve operational efficiency with a robust, durable design suitable for indoor and outdoor use</li>
              <li>Enhance customer engagement with tap-to-pay, mobile wallet, and loyalty program support</li>
              <li>Minimise risk with the latest PCI PTS 6.X and EMV Contactless certifications</li>
              <li>Flexible connectivity options: Ethernet, USB-C, and optional cellular</li>
            </ul>

            {/* PAYMENT METHODS */}
            <h3 className="payment-title">Multiple Payment Methods</h3>

            <div className="payment-logos">
              <img src="/images/7200/gpay.png" alt="GPay" />
              <img src="/images/7200/mc.png" alt="Mastercard" />
              <img src="/images/7200/amex.png" alt="Amex" />
              <img src="/images/7200/visa.png" alt="Visa" />
              <img src="/images/7200/apple.png" alt="Apple Pay" />
              <img src="/images/7200/samsung.png" alt="Samsung Pay" />
              <img src="/images/7200/alipay.png" alt="Alipay" />
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="benefits-right">
            <img
              src="/images/7200/1-6.png"
              alt="Kiosk"
            />
          </div>
        </div>
      </section>
      <section className="vp7200-features">
        <div className="vp7200-features-container">
          <div className="feature-item">
            <img src="/images/7200/flex-connect.png" alt="Connectivity" />
            <h4>Flexible Connectivity</h4>
            <p>Integrate seamlessly into your existing infrastructure.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/secure.png" alt="Security" />
            <h4>Secure & Compliant</h4>
            <p>Protect your business and customers with advanced security.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/rugged.png" alt="Rugged" />
            <h4>Rugged & Reliable</h4>
            <p>Built to withstand tough environments and 24/7 use.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/cust.png" alt="Customer" />
            <h4>Customer Engagement</h4>
            <p>Enhance the payment experience and drive loyalty.</p>
          </div>
        </div>
      </section>
      <section className="vp7200-specs">

        <div className="vp7200-specs-container">

          <h2 className="specs-title">Technical Specifications</h2>

          {/* ELECTRICAL */}
          <div className="spec-group">
            <div className="spec-label">ELECTRICAL</div>

            <div className="spec-content electrical">
              <div className="spec-row">
                <span>CONNECTIVITY</span>
                <p>ETHERNET, RS232, UART, USB-C, OPTIONAL CELLULAR/LTE</p>
              </div>

              <div className="spec-row">
                <span>CRYPTOGRAPHY</span>
                <p>RSA 204B, ECC 512, AES128, SHA1, SHA256 & SHA512</p>
              </div>

              <div className="spec-row">
                <span>KEY INJECTION</span>
                <p>PKI, REMOTE KEY INJECTION</p>
              </div>

              <div className="spec-row">
                <span>KEY MANAGEMENT</span>
                <p>AES DUKPT, TDES DUKPT, TRANSARMOR RSA & TDES</p>
              </div>

              <div className="spec-row">
                <span>POWER</span>
                <p>5V 2A</p>
              </div>

              <div className="spec-row">
                <span>SECURITY</span>
                <p>PCI PTS 6.X SRED, 4 SAM</p>
              </div>
            </div>
          </div>

          {/* ENVIRONMENTAL */}
          <div className="spec-group">
            <div className="spec-label">ENVIRONMENTAL</div>

            <div className="spec-content environmental">
              <div className="spec-row">
                <span>IMPACT RATING</span>
                <p>IK07</p>
              </div>

              <div className="spec-row">
                <span>INGRESS PROTECTION RATING</span>
                <p>IP65</p>
              </div>

              <div className="spec-row">
                <span>OPERATING ENVIRONMENT</span>
                <p>WATER RESISTANT FOR INDOOR & OUTDOOR USE</p>
              </div>

              <div className="spec-row">
                <span>OPERATING TEMPERATURE</span>
                <p>-30°C TO 70°C (MAX CHANGE OF 10°C PER/HOUR)</p>
              </div>

              <div className="spec-row">
                <span>STORAGE TEMPERATURE</span>
                <p>-30°C TO 85°C (NON-CONDENSING)</p>
              </div>
            </div>
          </div>

          {/* MECHANICAL */}
          <div className="spec-group">
            <div className="spec-label">MECHANICAL</div>

            <div className="spec-content mechanical">
              <div className="spec-row">
                <span>DIMENSIONS</span>
                <p>68MM (H) X 68MM (W) X 11.5 MM (D)</p>
              </div>

              <div className="spec-row">
                <span>MEMORY</span>
                <p>128MB FLASH, 64MB RAM: 24MB FOR CUSTOMER APPLICATION</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default VP7200;